import * as React from "react"
import {useEffect} from "react"
import {Grid} from "@mui/material";

import {HOME_ROUTES, PRODUCT_PAGE_ROUTES} from "@constants";
import PageWrapper from "Pages/@PageWrapper"
import { TourProvider, TourTarget } from "@tour"
import {isSystemBusy} from "@signals";
import {evolutionDataFilters, productPagesKpiIsEmpty} from "./@signals";
import ProductPagesKpiFilters from "./Filters";
import ProductPagesKpiTable from "./Table";
import ProductPageKPIEvolutionChart from "./EvolutionChart";
import ProductPageKpiReportFormDrawer from "./ReportForm";


export default function ProductPagesKpiPage() {

    useEffect(() => {
        return () => evolutionDataFilters.value = {}
    },[])

    return <PageWrapper
        tourPageKey="productPageKpi"
        head={`DIP Insight | ${PRODUCT_PAGE_ROUTES.KPIS_TITLE}`}
        title={PRODUCT_PAGE_ROUTES.KPIS_TITLE}
        subtitle={PRODUCT_PAGE_ROUTES.KPIS_SUBTITLE}
        isEmpty={productPagesKpiIsEmpty.value}
        filters={<ProductPagesKpiFilters />}
        hasErrors={isSystemBusy.value}
    >
        <Grid container spacing={2}>
            <Grid item xs={12} sx={{ position: "relative" }}>
                <TourTarget name="pp-kpi-table" height={350} />
                <ProductPagesKpiTable />
            </Grid>
            <Grid item xs={12}>
                <ProductPageKPIEvolutionChart />
            </Grid>
            <Grid item xs={12}>
                <ProductPageKpiReportFormDrawer />
            </Grid>
        </Grid>
    </PageWrapper>
}